import React from 'react';
import { FieldArray } from 'formik';
import { Box, TextField, Typography } from '@mui/material';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ProductForm from './ProductForm';
import BaseCodeSelectbox from '../../common/form/selectbox/BaseCodeSelectbox';

const DisposalForm = ({ formik, totalPrice }) => {
  return (
    <FieldArray
      name="prdtList"
      render={(arrayHelpers) => (
        <Box>
          {formik.values?.prdtList.length === 0 ? (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Typography variant="subtitle2" component="div">
                선택된 폐기 제품이 없습니다.
              </Typography>
            </Box>
          ) : (
            <Box>
              <Box sx={{ my: 2 }}>
                <Box>
                  <BaseCodeSelectbox
                    formik={formik}
                    filterObject={{
                      blcCd: 'BASE',
                      mlcCd: 'STOCK',
                      slcCd: 'DEL_TYP',
                      useYn: 'Y',
                    }}
                    margin="normal"
                    name="delTyp"
                    label="폐기 타입"
                    variant="outlined"
                    required={true}
                  />
                </Box>
                <Box>
                  <TextField
                    margin="normal"
                    required={true}
                    variant="outlined"
                    fullWidth
                    id="delDesc"
                    name="delDesc"
                    label="폐기 사유"
                    value={formik.values.delDesc}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.delDesc && Boolean(formik.errors.delDesc)
                    }
                    helperText={formik.touched.delDesc && formik.errors.delDesc}
                    multiline
                    rows={4}
                  />
                </Box>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  pb: 2,
                  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                }}
              >
                <Box>
                  <Typography variant="subtitle2" component="div">
                    총 {formik.values?.prdtList.length}건
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="subtitle2" component="div">
                    총합 : ₩{' '}
                    {totalPrice
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  </Typography>
                </Box>
              </Box>
              <TableContainer component={Box}>
                <Table size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell>No</TableCell>
                      <TableCell>제조사</TableCell>
                      <TableCell>매입처</TableCell>
                      <TableCell>제품명</TableCell>
                      <TableCell>모델명</TableCell>
                      <TableCell>수량</TableCell>
                      <TableCell>단가</TableCell>
                      <TableCell>삭제</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {formik.values?.prdtList.map((p, index) => {
                      return (
                        <ProductForm
                          key={index}
                          product={p}
                          index={index}
                          formik={formik}
                          handleRemove={() => arrayHelpers.remove(index)}
                        />
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          )}
        </Box>
      )}
    ></FieldArray>
  );
};

export default DisposalForm;
